<template lang="pug">

el-container(style="height: 100vh" direction="vertical")
  publicHeader
  
  el-main
    .forgot
      h1 再設定メールを送信しました
      p 一定時間経過してもメールが届かない場合は、再度お試しください。
      
      el-row(type="flex" justify="center")
        el-button(type="primary" @click="goSignIn") {{ $t('sign_in.back_signin') }}

  publicFooter

</template>

<script>
import Header from './Header.vue'
import Footer from './Footer.vue'

export default {
  data(){
    return {
    }
  },
  created() {
  },
  components: {
    'publicHeader': Header,
    'publicFooter': Footer
  },
  methods: {
    goSignIn: function(){
      this.$router.replace('/sign_in')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";

.forgot {
  width: 320px;
  margin: 20px auto 0 auto;
  background: #FFF;
  padding: 40px;
  border-radius: 5px;
  border: 1px solid $border;
  
  h1 {
    font-size: 16px;
  }
  p {
    color: #666;
    font-size: 13px;
    margin-bottom: 40px;
  }
}

.el-button {
  width: 100%;
  font-size: 16px;
  padding: 20px 0;
}

</style>